<eventq-dialog-popover
  [open]="open()"
  title="Raise Event"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="confirmDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="raise-event-popover__body">
    <eventq-popover-search
      [value]="searchQuery()"
      (valueChange)="searchQueryChange.emit($event)"
    />

    <eventq-priority-filter-row
      [options]="priorityOptions()"
      [selectedPriorities]="selectedPriorities()"
      (selectedPrioritiesChange)="selectedPrioritiesChange.emit($event)"
    />

    <eventq-event-outcome-list
      [groups]="groups()"
      [selectedOutcomeId]="selectedOutcomeId()"
      [selectedPriorities]="selectedPriorities()"
      [searchQuery]="searchQuery()"
      (selectedOutcomeIdChange)="selectedOutcomeIdChange.emit($event)"
    />
  </div>
</eventq-dialog-popover>
